// tokenCleaner.js

/**
 * Cleans up hyphens from all token elements with the class 'token-cleaner' and capitalizes the first word.
 * This function will loop through all elements with the 'token-cleaner' class
 * and remove the hyphens from their text content and capitalize the first word.
 */
export function cleanToken() {
  document.addEventListener('DOMContentLoaded', function () {
    // Find all elements with the class 'token-cleaner'
    const tokenElements = document.querySelectorAll('.token-cleaner')

    tokenElements.forEach(function (tokenElement) {
      // Get the text content of the element
      const tokenText = tokenElement.textContent || tokenElement.innerText

      // Remove hyphens from the text
      let cleanedText = tokenText.replace(/-/g, ' ') // Replace hyphens with a space

      // Capitalize the first letter of the first word
      cleanedText = cleanedText.charAt(0).toUpperCase() + cleanedText.slice(1)

      // Set the cleaned text back to the element
      tokenElement.textContent = cleanedText
    })
  })
}
